// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   COREUI / BOOTSTRAP COMPONENT THEMING
   Bootstrap 5 + CoreUI already remap most colors automatically via
   [data-bs-theme] / [data-coreui-theme]. These rules cover the spots
   that need an explicit nudge to match our brand tokens.
   ========================================================= */

.card {
  background-color: var(--card-bg);
  border-color: var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 1px 3px var(--shadow);
  color: var(--text-primary);
}

.btn {
  border-radius: var(--radius-md);
  font-weight: 600;
}

.btn-primary {
  background-color: var(--primary);
  border-color: var(--primary);
}
.btn-primary:hover,
.btn-primary:focus {
  background-color: var(--primary-hover);
  border-color: var(--primary-hover);
}

.btn-outline-primary {
  color: var(--primary);
  border-color: var(--primary);
}
.btn-outline-primary:hover {
  background-color: var(--primary);
  border-color: var(--primary);
}

.text-primary {
  color: var(--primary) !important;
}
.bg-primary {
  background-color: var(--primary) !important;
}

.form-control,
.form-select {
  background-color: var(--card-bg);
  border-color: var(--border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
}
.form-control:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem color-mix(in srgb, var(--primary) 15%, transparent);
}

.alert-danger {
  --bs-alert-bg: rgba(220, 53, 69, 0.1);
  --bs-alert-border-color: rgba(220, 53, 69, 0.25);
  --bs-alert-color: #e35d6a;
}

.badge.bg-info {
  background-color: var(--primary) !important;
}

/* Sidebar */
.sidebar {
  background-color: var(--card-bg);
  border-right: 1px solid var(--border);
}
.sidebar .nav-link {
  color: var(--text-secondary);
}
.sidebar .nav-link:hover {
  color: var(--text-primary);
  background-color: var(--hover);
}
.sidebar .nav-group-toggle::after {
  filter: none;
}

/* Tabs (react-bootstrap) */
.nav-tabs {
  border-bottom-color: var(--border);
}
.nav-tabs .nav-link {
  color: var(--text-secondary);
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
}
.nav-tabs .nav-link:hover {
  color: var(--primary);
  border-bottom-color: var(--border);
}
.nav-tabs .nav-link.active {
  color: var(--primary);
  background: transparent;
  border-bottom-color: var(--primary);
  font-weight: 600;
}

/* Carousel controls already styled in carousel.css via filter,
   keep the caret/icon visible on dark backgrounds too */
[data-theme="dark"] .carousel .carousel-control-prev,
[data-theme="dark"] .carousel .carousel-control-next {
  filter: invert(0);
  opacity: 0.85;
}

/* Spinner */
.spinner-border.text-primary {
  color: var(--primary) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/coreui-overrides.css"],"names":[],"mappings":"AAAA;;;;;8DAK8D;;AAE9D;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,qCAAqC;EACrC,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,qCAAqC;AACvC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;wDACwD;AACxD;;EAEE,iBAAiB;EACjB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,gCAAgC;AAClC","sourcesContent":["/* =========================================================\n   COREUI / BOOTSTRAP COMPONENT THEMING\n   Bootstrap 5 + CoreUI already remap most colors automatically via\n   [data-bs-theme] / [data-coreui-theme]. These rules cover the spots\n   that need an explicit nudge to match our brand tokens.\n   ========================================================= */\n\n.card {\n  background-color: var(--card-bg);\n  border-color: var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 1px 3px var(--shadow);\n  color: var(--text-primary);\n}\n\n.btn {\n  border-radius: var(--radius-md);\n  font-weight: 600;\n}\n\n.btn-primary {\n  background-color: var(--primary);\n  border-color: var(--primary);\n}\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: var(--primary-hover);\n  border-color: var(--primary-hover);\n}\n\n.btn-outline-primary {\n  color: var(--primary);\n  border-color: var(--primary);\n}\n.btn-outline-primary:hover {\n  background-color: var(--primary);\n  border-color: var(--primary);\n}\n\n.text-primary {\n  color: var(--primary) !important;\n}\n.bg-primary {\n  background-color: var(--primary) !important;\n}\n\n.form-control,\n.form-select {\n  background-color: var(--card-bg);\n  border-color: var(--border);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n}\n.form-control:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 0.2rem color-mix(in srgb, var(--primary) 15%, transparent);\n}\n\n.alert-danger {\n  --bs-alert-bg: rgba(220, 53, 69, 0.1);\n  --bs-alert-border-color: rgba(220, 53, 69, 0.25);\n  --bs-alert-color: #e35d6a;\n}\n\n.badge.bg-info {\n  background-color: var(--primary) !important;\n}\n\n/* Sidebar */\n.sidebar {\n  background-color: var(--card-bg);\n  border-right: 1px solid var(--border);\n}\n.sidebar .nav-link {\n  color: var(--text-secondary);\n}\n.sidebar .nav-link:hover {\n  color: var(--text-primary);\n  background-color: var(--hover);\n}\n.sidebar .nav-group-toggle::after {\n  filter: none;\n}\n\n/* Tabs (react-bootstrap) */\n.nav-tabs {\n  border-bottom-color: var(--border);\n}\n.nav-tabs .nav-link {\n  color: var(--text-secondary);\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n}\n.nav-tabs .nav-link:hover {\n  color: var(--primary);\n  border-bottom-color: var(--border);\n}\n.nav-tabs .nav-link.active {\n  color: var(--primary);\n  background: transparent;\n  border-bottom-color: var(--primary);\n  font-weight: 600;\n}\n\n/* Carousel controls already styled in carousel.css via filter,\n   keep the caret/icon visible on dark backgrounds too */\n[data-theme=\"dark\"] .carousel .carousel-control-prev,\n[data-theme=\"dark\"] .carousel .carousel-control-next {\n  filter: invert(0);\n  opacity: 0.85;\n}\n\n/* Spinner */\n.spinner-border.text-primary {\n  color: var(--primary) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
